export default __webpack_public_path__ + "static/media/up.10c7b3e7.svg";